import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';

const highlight = (value, text) => {
  if (!value) {
    return text;
  }

  const parsedValue = value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const regex = new RegExp(`(${parsedValue})`, 'i');
  if (text) {
    return text.replace(regex, "<span class='highlighter__highlighted'>$1</span>");
  }
  return '';
};

/**
Il componente Highlighter ha lo scopo di evidenziare una parola all'interno di un testo passato ed
è generalmente usato per evidenziare le occorrenze di una parola cercata in modo da aiutare l'utente a
identificarne le occorrenze in un testo lungo.
 */
const Highlighter = ({ value: valueP, text: textP, className }) => {
  const classes = cns(
    'highlighter__text',
    className,
  );

  return (
    <span
      className={classes}
      dangerouslySetInnerHTML={{ __html: highlight(valueP, textP) }}
    />
  );
};

Highlighter.propTypes = {
  /** Classi css personalizzate da aggiungere al componente */
  className: PropTypes.string,
  /** Il testo in cui ricercare il valore da evidenziare */
  text: PropTypes.string,
  /** Il valore da evidenziare */
  value: PropTypes.string,
};

Highlighter.defaultProps = {
  className: '',
  value: null,
  text: '',
};

export default Highlighter;
